<template>
	<section v-if="items.length" class="faq-section align-center">
		<div class="row faq">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div class="columns column12">
					<div class="collapse-container">
						<collapse v-for="item in items" :key="item.ID" :header="item.header" :content="item.content" />
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	header: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.faq-section {
	h2 {
		margin-bottom: 50px;
	}

	.collapse-container {
		background-color: #f9f9f9;
	}
}
</style>
